var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronRightCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.854,
    height: 55.853,
    viewBox: "0 0 55.854 55.853",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Knop4Rechts",
    d: "M27.926,55.853A27.927,27.927,0,0,1,8.179,8.179a27.928,27.928,0,0,1,39.5,39.495A27.747,27.747,0,0,1,27.926,55.853Zm4.34-40.143a1.461,1.461,0,0,0-1.039.43L20.484,26.883a1.477,1.477,0,0,0,0,2.086L31.227,39.708a1.462,1.462,0,0,0,2.08,0,1.475,1.475,0,0,0,0-2.081L24.651,28.97a1.481,1.481,0,0,1,0-2.086l8.657-8.657a1.481,1.481,0,0,0,0-2.086A1.462,1.462,0,0,0,32.266,15.71Z",
    transform: "translate(55.854 55.853) rotate(180)",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightCircle);
export default __webpack_public_path__ + "static/media/ChevronRightCircle.e7c98918684c7a74ee703726b9339de2.svg";
export { ForwardRef as ReactComponent };